<template>
  <div class="chat-container">
    <Chat v-if="getIsOpen"/>
    <FloatingIcon/>
  </div>
</template>

<script>
import Chat from './Chat'
import FloatingIcon from './FloatingIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'Widget',
  components: {
    Chat,
    FloatingIcon
  },
  computed: {
    ...mapGetters({
      getIsOpen: 'chat/getIsOpen'
    })
  }
}
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;600&display=swap');

 .chat-container {
   position: fixed;
   right: 30px;
   bottom: 30px;
   display: flex;
   flex-direction: column;
   align-items: baseline;
   width: 350px;
   z-index: 99;
   @media (max-width: 400px) {
     width: 300px;
   }
 }

</style>
